import React, { Component } from 'react';
import Modal from './_Modal';
import styled from 'styled-components';
import Select from 'react-select';

import { TAGS } from './helpers/tagsHelper';

const Wrapper = styled.div`
  text-align: center;
`
const AlignLeft = styled.div`
  width: 500px;
  text-align: left;
  Input, TextArea {
    margin-bottom: 10px;
  }
`
const Input = styled.input`
  width: 100%;
`
const TextArea = styled.textarea`
  width: 100%;
`
const Buttons = styled.div`
  text-align: center;
  margin-top: 15px;
  button {
    background-color: #69f;
    border: none;
    border-radius: 5px;
    margin: 20px;
    color: white;
    &:hover {
      background-color: #36e;
    }
  }
`

class SettingsModal extends Component {
  constructor() {
    super()
    this.state = {
      // name: '',
      // description: '',
      tagOptions: TAGS
    }
  }
  handleTagChange = (tags) => {
    this.props.changeTags(tags)
  }

  render() {
    var { name, description, tags } = this.props.envelope ? this.props.envelope :
    { name: '', description: '', tags: "[]" };
    tags = JSON.parse(tags);

    return (
    <Modal
      open={this.props.open}
      close={() => this.props.closeModal(this.props.method)}
    >
      <Wrapper>
        <h3>Settings</h3>
        <hr />
        <AlignLeft>
          <div>Name:</div>
          <Input
            autoFocus
            onChange={this.props.changeName}
            value={name}>
          </Input>
          <div>Description:</div>
          <TextArea onChange={this.props.changeDescription} value={description}></TextArea>
          <div>Tags:</div>
          <Select
            multi
            value={tags}
            placeholder="Add some tags"
            options={this.state.tagOptions}
            onChange={this.handleTagChange}
            onFocus={this.focusHandler}
          />
          <Buttons>
            <button onClick={() => this.props.closeModal(this.props.method)}>Go Back</button>
            <button onClick={() => {this.props.saveEnvelope(); this.props.closeModal(this.props.method)}}>Save Envelope</button>
          </Buttons>
        </AlignLeft>
      </Wrapper>
    </Modal>
    )
  }
}

export default SettingsModal;



// WEBPACK FOOTER //
// ./src/_SettingsModal.js